import styled from 'styled-components';
import { color } from '../../resources';

// ระบายสีแถวตามจำนวนเคลมของประกันใบนั้น (3-4 เหลือง, 5 ขึ้นไปแดง) แทนสถานะหมดอายุแบบเดิม
export const StyledCustomerHistory = styled.div`
  .claim-count-row-warning > td {
    background-color: #fffbe6 !important;
  }
  .claim-count-row-warning:hover > td {
    background-color: #fff1b8 !important;
  }
  .claim-count-row-danger > td {
    background-color: #fff1f0 !important;
    color: ${color.red2};
  }
  .claim-count-row-danger:hover > td {
    background-color: #ffd8d3 !important;
  }
`;
